var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-row',[_c('v-col',{style:({
        font: ("normal normal 600 " + (_vm.$vuetify.breakpoint.lgAndUp ? '26px' : '19px') + " Poppins"),
        color: '#000B8D',
        minHeight: '36px'
      })},[_c('div',[_vm._v(_vm._s(_vm.form.title))])])],1),_c('v-row',[_c('v-col',{style:({
        font: 'normal normal normal 16px/19px Lato',
        color: '#333333'
      })},[_vm._v(_vm._s(_vm.form.subTitle))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }